import React, {Component} from 'react';
import {FormattedMessage, injectIntl} from "react-intl";
import {Card, Tabs} from "antd";
import Constants from "../../services/Constants";
import SAInputLabel from "../common/input/SAInputLabel";
import ActiveDateSelect from "./ActiveDateSelect";
import {connect} from "react-redux";
import {MEDIA_MESSAGE_BMW, MEDIA_MESSAGE_MINI} from "./MediaType";
import SATextArea from "../common/input/SATextArea";
import SAInputComponent from "../common/input/SAInputComponent";
import {SpinnerModal} from "../../public/components/SpinnerModal";

class MessageConfiguration extends Component {

  constructor(props) {
    super(props);
    this.state = {
      MESSAGE_BMW: {
        active: false,
        type: MEDIA_MESSAGE_BMW,
        messages:{},
      },
      MESSAGE_MINI: {
        active: false,
        type: MEDIA_MESSAGE_MINI,
        messages:{},
      },
      pristine: false
    };
  }

  componentDidMount() {
    this.props.dispatchFetchMessages();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.messages) {
      this.setState({...nextProps.messages});
    }
  }

  onSave = () => {
    const {MESSAGE_BMW, MESSAGE_MINI} = this.state;
    this.props.dispatchUpdateMessages({
      MESSAGE_BMW,
      MESSAGE_MINI
    });
  };

  onPropertyUpdate = (property, data) => {
    this.setState({[property]: data, pristine: true})
  };

  onCommunicationChange = (e, brand, lang) => {
    const property = this.state[brand];
    const {target: {name, value}} = e;
    const {messages = {}} = property;
    messages[lang] = {...(messages[lang] || {}), [name]: value};
    this.setState({[brand]: property, pristine: true})
  };

  render() {
    const {intl: {formatMessage}, loading, errors = {}} = this.props;
    const {MESSAGE_BMW = {}, MESSAGE_MINI = {}, pristine} = this.state;

    return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            <FormattedMessage id="section.communication.message-configuration"/>
          </h2>
          <div className="box-heading__button">
            <button type="primary" disabled={!pristine} className="btn btn-sm btn-primary" onClick={() => this.onSave()}>
              <FormattedMessage id="action.save"/>
            </button>
          </div>
        </header>

        <div className="box__body">
          <div className="row">
            <SpinnerModal visible={loading}/>
            <div className="col-md-6 col-xxl-6">
              <h3 className="box__subtitle">BMW</h3>
                <ActiveDateSelect data={MESSAGE_BMW} errors={{from: errors['messages[MESSAGE_BMW].from'], to: errors['messages[MESSAGE_BMW].to']}}
                                  onChange={data => this.onPropertyUpdate("MESSAGE_BMW", data)} />

                <Tabs type="card" defaultActiveKey="en">
                  {Constants.SUPPORTED_LANGUAGES.map(lang => {
                    const error = errors[`messages[MESSAGE_BMW].messages[${lang}]`] || errors[`messages[MESSAGE_BMW].messages[${lang}].url`] || errors[`messages[MESSAGE_BMW].messages[${lang}].textMessage`];
                    return (
                      <Tabs.TabPane key={lang} tab={<span className={error ? 'txt-error': ''}>{formatMessage({id: lang})}</span>}>
                        <Card>
                          <SAInputComponent label={formatMessage({id: "communication.message.text"})}>
                            <SATextArea name="textMessage" value={MESSAGE_BMW.messages && MESSAGE_BMW.messages[lang] && MESSAGE_BMW.messages[lang].textMessage} autosize={true}
                                        onChange={e => this.onCommunicationChange(e, "MESSAGE_BMW", lang)}
                                        error={errors[`messages[MESSAGE_BMW].messages[${lang}]`] || errors[`messages[MESSAGE_BMW].messages[${lang}].textMessage`]}
                            />
                          </SAInputComponent>
                          <SAInputLabel name="url" value={MESSAGE_BMW.messages && MESSAGE_BMW.messages[lang] && MESSAGE_BMW.messages[lang].url} label="communication.message.url"
                                        onChange={e => this.onCommunicationChange(e, "MESSAGE_BMW", lang)} error={errors[`messages[MESSAGE_BMW].messages[${lang}]`] || errors[`messages[MESSAGE_BMW].messages[${lang}].url`]}/>
                        </Card>
                      </Tabs.TabPane>
                  )})}
                </Tabs>
              </div>

              <div className="col-md-6 col-xxl-6">
                <h3 className="box__subtitle">Mini</h3>
                <ActiveDateSelect data={MESSAGE_MINI} errors={{from: errors['messages[MESSAGE_MINI].from'], to: errors['messages[MESSAGE_MINI].to']}}
                                  onChange={data => this.onPropertyUpdate("MESSAGE_MINI", data)} />

                <Tabs type="card" defaultActiveKey="en">
                  {Constants.SUPPORTED_LANGUAGES.map(lang => {
                    const error = errors[`messages[MESSAGE_MINI].messages[${lang}]`] || errors[`messages[MESSAGE_MINI].messages[${lang}].url`] || errors[`messages[MESSAGE_MINI].messages[${lang}].textMessage`];
                    return (
                      <Tabs.TabPane key={lang} tab={<span className={error ? 'txt-error': ''}>{formatMessage({id: lang})}</span>}>
                        <Card>
                          <SAInputComponent label={formatMessage({id: "communication.message.text"})}>
                            <SATextArea name="textMessage" value={MESSAGE_MINI.messages && MESSAGE_MINI.messages[lang] && MESSAGE_MINI.messages[lang].textMessage} autosize={true}
                                        onChange={e => this.onCommunicationChange(e, "MESSAGE_MINI", lang)}
                                        error={errors[`messages[MESSAGE_MINI].messages[${lang}]`] || errors[`messages[MESSAGE_MINI].messages[${lang}].textMessage`]}
                            />
                          </SAInputComponent>
                          <SAInputLabel name="url" value={MESSAGE_MINI.messages && MESSAGE_MINI.messages[lang] && MESSAGE_MINI.messages[lang].url} label="communication.message.url"
                                        onChange={e => this.onCommunicationChange(e, "MESSAGE_MINI", lang)} error={errors[`messages[MESSAGE_MINI].messages[${lang}]`] || errors[`messages[MESSAGE_MINI].messages[${lang}].url`]}/>
                        </Card>
                      </Tabs.TabPane>
                  )})}
                </Tabs>
              </div>
            </div>
        </div>
      </section>
    )
  }
}

const mapStateToProps = state => ({
  messages: state.fetchNscMessages && state.fetchNscMessages.body,
  loading: state.fetchNscMessages.loading,
  errors: (state.fetchNscMessages.error || {}).content
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchMessages: () => dispatch({type: 'FETCH.COMMUNICATION_MESSAGES.REQUEST'}),
  dispatchUpdateMessages: body => dispatch({type: 'SAVE.COMMUNICATION_MESSAGES.REQUEST', body})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(MessageConfiguration));



// WEBPACK FOOTER //
// ./src/components/communication/MessageConfiguration.js